var img = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 26 26'%3e%3ccircle cx='13' cy='13' r='13' fill='white'/%3e%3cpath stroke='%2356368F' stroke-linecap='round' stroke-width='2' d='M13 19V8'/%3e%3cpath stroke='%2356368F' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M8.5 12.5 13 8l4.5 4.5'/%3e%3c/svg%3e";
  var up = img;

export { up as default };
//# sourceMappingURL=up.svg.js.map
